import React from 'react';
import styled, { keyframes } from 'styled-components';

interface LoadingStateProps {
  message?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading data…'
}) => (
  <Wrapper>
    <Spinner />
    <Message>{message}</Message>
  </Wrapper>
);

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  gap: 16px;
`;

const Spinner = styled.div`
  width: 28px;
  height: 28px;
  border: 2.5px solid var(--line);
  border-top-color: var(--ink-muted);
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;

const Message = styled.span`
  font-size: 13px;
  color: var(--ink-faint);
  font-weight: 500;
`;
